import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const TranslateButtonContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  overflow: hidden;
  position: relative;
  background-color: ${(props) => props.theme.color.light.tint};
  border-radius: 8px;
  padding: 10px;
  width: fit-content;
  align-items: center;
  ${mediaQuery('small')} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TranslateButton = styled.div`
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
`;
